import React, {  } from 'react'
import Calendar from 'react-calendar';
import { useHistory } from "react-router-dom"
import { useSelector } from 'react-redux'
import { EyeCloseIcon } from '../../../assets/icons'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import Input from '../../../utils/components/Input/Input'
import useModal from '../../../utils/hooks/useModal'
import { usePlaces } from '../../../utils/hooks/usePlaces'
import style from './EditProfileView.module.css'
import './EditProfile.css'

const EditProfileView = ({ formik }) => {
    const history = useHistory()

    usePlaces(formik.values.ubication.currentCountry, formik.values.ubication.currentDepartment)
    const { countries, states, cities } = useSelector(state => state.locations)

    const [refPrivate, isShowPrivate, setIsShowPrivate] = useModal(false)
    const [refDate, isShowDate, setIsShowDate] = useModal(false)
    return (
        <div className="">
            <div className="title-register">{Translate('editYourProfile', 'es')}</div>
            <div className="content-edit-profile">
              

                <div className="content-data-edit-profile">
                    <div className="content-inputs-edit-profile">
                        {
                            true && (<>
                                <Input
                                    name="name"
                                    type="text"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={formik.errors.name}
                                    placeholder={'*Nombres'}
                                />
                                <Input
                                    name="lastname"
                                    type="text"
                                    value={formik.values.lastname}
                                    onChange={formik.handleChange}
                                    error={formik.errors.lastname}
                                    placeholder={'*Apellidos'}
                                /></>)

                        }

                        <Input
                            name="phone"
                            type="text"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            error={formik.errors.phone}
                            placeholder={'*Teléfono'}
                        />
                        <div ref={refDate}>
                            <Input
                                name="birthDate"
                                readOnly
                                value={new Date(formik.values.birthDate || new Date()).toLocaleDateString()}
                                onClick={() => setIsShowDate(true)}
                                error={formik.errors.birthDate}
                                placeholder={'*Fecha de nacimiento'}
                            />
                            {isShowDate &&
                                <div style={{
                                    display: isShowDate ? 'block' : 'none'
                                }}
                                    className="calendar-register"
                                >
                                    <Calendar

                                        onChange={(dateTime) => formik.setFieldValue("birthDate", dateTime)}
                                        value={new Date(formik.values.birthDate)}
                                    />
                                </div>
                            }
                        </div>

                        <select
                            name={"gender"}
                            className='input-select-style'
                            value={formik.values.gender}
                            onChange={formik.handleChange}>
                            <option value="">{Translate("gender", 'es')}</option>
                            <option value="male">Masculino</option>
                            <option value="female">Femenino</option>
                            <option value="another">Prefiero no decirlo</option>
                        </select>
                        <Input
                            name="username"
                            type="text"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={formik.errors.username}
                            placeholder={'Digita tu usuario'}
                        />
                        {
                            true && <>
                                <div>
                                    <select className='input-select-style' name="ubication.currentCountry" value={formik.values.ubication.currentCountry} onChange={formik.handleChange}>
                                        <option value="">País</option>
                                        {countries.map((country) => (
                                            <option key={country.countryID} value={country.countryName}>
                                                {country.countryName}
                                            </option>
                                        )
                                        )}
                                    </select>
                                </div>
                                <select className='input-select-style' name="ubication.currentDepartment" value={formik.values.ubication.currentDepartment} onChange={formik.handleChange}>
                                    <option value="">Departamento</option>
                                    {states.map((state) => (
                                        <option key={state.stateID} value={state.stateName}>
                                            {state.stateName}
                                        </option>
                                    )
                                    )}
                                </select>
                                <select className='input-select-style' name="ubication.currentCity" value={formik.values.ubication.currentCity} onChange={formik.handleChange}>
                                    <option value="">Ciudad</option>
                                    {cities.map((city) => (
                                        <option key={city.cityID} value={city.cityName}>
                                            {city.cityName}
                                        </option>
                                    )
                                    )}
                                </select>
                            </>
                        }
                        <Input
                            name="ubication.currentLocation"
                            type="text"
                            value={formik.values.ubication.currentLocation}
                            onChange={formik.handleChange}
                            error={formik.errors.currentLocation}
                            placeholder={'Barrio'}
                        />
                        <Input
                            name="ubication.currentAddress"
                            type="text"
                            value={formik.values.ubication.currentAddress}
                            onChange={formik.handleChange}
                            error={formik.errors.currentAddress}
                            placeholder={'Dirección de residencia'}
                        />

                        <Input
                            name="hobbies"
                            type="text"
                            value={formik.values.hobbies}
                            onChange={formik.handleChange}
                            error={formik.errors.hobbies}
                            placeholder={'hobbies'}
                        />
                        <Input
                            name="aspiration"
                            type="text"
                            value={formik.values.aspiration}
                            onChange={formik.handleChange}
                            error={formik.errors.aspiration}
                            placeholder={'Sueño'}
                        />
                    </div>
                    <div>
                        <div className={`${style.pointer}`} onClick={() => setIsShowPrivate(true)}>
                            <EyeCloseIcon height={20} /> <span> Seleccionar privacidad de la información </span>
                        </div>
                    </div>
                    <Button onClick={formik.handleSubmit} classNameContent={"button-save-edit-profile"} text={Translate('save', 'es')} theme="white" />
                    <Modal displayModal={isShowPrivate} close={() => setIsShowPrivate(false)} formik={formik} />
                </div>
            </div>
        </div>
    )
}
const Modal = ({ formik, displayModal, close }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }

    return (
        <div className={"modal"} style={divStyle}>
            <div className="modal-content">
                <div className="content-privacity-edit-profile">
                    <div className='column'>

                        <input
                            type='checkbox'
                            checked={formik.values.privateData.email === 1}
                            value={formik.values.privateData.email}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    formik.setFieldValue('privateData.email', 1)
                                }
                                else {
                                    formik.setFieldValue('privateData.email', 0)
                                }
                            }} />
                        <label className="privacity-label" >Hacer visible mi email</label>
                    </div>
                    <div className='column'>

                        <input type='checkbox' checked={formik.values.privateData.birthDate === 1}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    formik.setFieldValue('privateData.birthDate', 1)
                                } else {
                                    formik.setFieldValue('privateData.birthDate', 0)
                                }

                            }} />
                        <label className="privacity-label" >Hacer visible mi fecha de nacimiento</label>
                    </div>
                    <div className='column'>

                        <input type='checkbox' checked={formik.values.privateData.phone === 1} onChange={(e) => {
                            if (e.target.checked) {
                                formik.setFieldValue('privateData.phone', 1)
                            } else {
                                formik.setFieldValue('privateData.phone', 0)
                            }

                        }} />
                        <label className="privacity-label" >Hacer visible mi numero de celular</label>
                    </div>
                    <div className='column'>

                        <input type='checkbox' checked={formik.values.privateData.ubication === 1} onChange={(e) => {
                            if (e.target.checked) {
                                formik.setFieldValue('privateData.ubication', 1)
                            } else {
                                formik.setFieldValue('privateData.ubication', 0)
                            }

                        }} />
                        <label className="privacity-label" >Hacer visible mi ubicación</label>
                    </div>
                    <div className='column'>

                        <input type='checkbox' checked={formik.values.privateData.gender === 1} onChange={(e) => {
                            if (e.target.checked) {
                                formik.setFieldValue('privateData.gender', 1)
                            } else {
                                formik.setFieldValue('privateData.gender', 0)
                            }

                        }} />
                        <label className="privacity-label" >Hacer visible mi genero</label>
                    </div>
                </div>
                <div className='column centerContent'>
                    <Button text='Cerrar' onClick={close} />
                </div>

            </div>
        </div>
    )


}
export default EditProfileView
